module.exports = __webpack_public_path__ + "static/media/50_B.06b9dc09.png";